import { classed, deriveClassed } from '@tw-classed/react'
import React from 'react'
import { cls } from 'tagged-classnames-free'

import { FluentFlexContext } from '../Root/Context'


import { useContext } from 'react';
const ItemBase = classed('div')

export type ItemProps = React.ComponentProps<typeof ItemBase> & {
  debug?: boolean
}

const Item = deriveClassed<typeof ItemBase, ItemProps>((props, ref) => {
  const { children, className, debug, ...rest } = props

  const { itemClassName } = useContext(FluentFlexContext)

  return (
    <ItemBase
      className={cls`
        ${itemClassName}
        ${className}
      `}
      {...rest}
      ref={ref}
    >
      {children}
    </ItemBase>
  )
})

export default Item
